import styled from "styled-components";
export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  .details {
    font-size: 16px;
    p span {
      font-weight: 600;
    }
  }
  .ant-slider-rail {
    height: 19px;
    border-radius: 8px;
    background-color: rgba(0, 191, 165, 0.5) !important;
    &:hover {
      background-color: rgba(0, 191, 165, 0.5);
    }
  }
  .total {
    align-self: center;
    font-size: 16px;
    span {
      font-weight: 600;
    }
  }
`;
